/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.29",
    versionName: "0.2.0-nightly.2025.8.29",
    versionChannel: "nightly",
    buildDate: "2025-08-29T00:07:14.079Z",
    commitHash: "7ef571df79e5f8ad7e1d964a8a1a82a6d0a60d5f",
};
